/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TargetAllegato } from './target-allegato';
import { PraticaEventoPayload } from './pratica-evento-payload';
import { OrigineAllegato } from './origine-allegato';


export interface AllegatoPayload extends PraticaEventoPayload { 
    allegato_id?: string;
    origine?: OrigineAllegato;
    target?: TargetAllegato;
    label?: string;
}



